export const ValidGDUCrops = {
	Corn: "Corn",
	Soybeans: "Soybeans",
	SweetCorn: "Sweet Corn",
	WinterWheat: "Winter Wheat",
	Cucumbers: "Cucumbers",
	Asparagus: "Asparagus",
	Barley: "Barley",
	Beets: "Beets",
	Broccoli: "Broccoli",
	Canola: "Canola",
	Carrots: "Carrots",
	Collards: "Collards",
	Cotton: "Cotton",
	Eggplants: "Eggplants",
	Flax: "Flax",
	Lettuce: "Lettuce",
	Muskmelon: "Muskmelon",
	Oats: "Oats",
	Okra: "Okra",
	Onions: "Onions",
	Peas: "Peas",
	Peanuts: "Peanuts",
	Peppers: "Peppers",
	Potatoes: "Potatoes",
	Rice: "Rice",
	Rye: "Rye",
	SnapBeans: "Snap Beans",
	Sorghum: "Sorghum",
	Squash: "Squash",
	Strawberry: "Strawberry",
	Sunflower: "Sunflower",
	SweetPotato: "Sweet Potato",
	Tomatoes: "Tomatoes",
	Watermelon: "Watermelon",
	SpringWheat: "Spring Wheat",
};
